import { PayloadAction } from '@reduxjs/toolkit';

import { DraftState, VariantInfo } from '../slice';

const setVariantsReducer = (state: DraftState, action: PayloadAction<{ [variantId: string]: VariantInfo }>) => {
  Object.assign(state.variants, action.payload);
};

export default setVariantsReducer;
